export default {
    user(state) {
        return state.user;
    },
    token(state) {
        return state.token;
    },
    tracker(state) {
        return state.tracker;
    },
};
